export default "__VITE_PUBLIC_ASSET__a57874e3__"